module.exports = __webpack_public_path__ + "img/9.80dbc02c.jpg";